import { AxiosError } from 'axios';

import { FunusCustomError } from 'config/apiErrors/FunusCustomError';

export class RequiredBackSideIAError extends FunusCustomError {
  constructor(error: AxiosError) {
    super(error);
    this.message = 'error.ia.backSideRequired';
    this.name = 'RequiredPDFTypeIAError';
  }
}
